"use strict";

exports.__esModule = true;
exports.DataItemPopoverContent = DataItemPopoverContent;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _Device = require("../../../Device");
var _Core = require("../../../Core");
var _Theme = require("../../../Theme");
var _icons = require("@blueprintjs/icons");
var _reactIntl = require("react-intl");
var _SelectorFormGroups = require("./SelectorFormGroups");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SaveButton = _styledComponents["default"].div.withConfig({
  displayName: "DataItemPopoverContent__SaveButton",
  componentId: "sc-t1sqcp-0"
})(["display:flex;justify-content:flex-end;padding:20px;padding-top:0px;"]);
var DataItemPopoverContentContainer = _styledComponents["default"].div.withConfig({
  displayName: "DataItemPopoverContent__DataItemPopoverContentContainer",
  componentId: "sc-t1sqcp-1"
})(["button[data-testid=\"Selector.selectorButton\"]{width:100%;padding-right:15px;}background-color:", ";"], function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
});
function DataItemPopoverContent(props) {
  var _useContext = (0, _react.useContext)(_Core.TranslatorContext),
    translate = _useContext.translate;
  var dataItems = props.dataItems,
    isMultiSelector = props.isMultiSelector,
    onSubmit = props.onSubmit,
    device = props.device,
    colorSelector = props.colorSelector,
    allowedCategories = props.allowedCategories,
    ignoredCategories = props.ignoredCategories,
    enableAddingNewItem = props.enableAddingNewItem;
  var _useState = (0, _react.useState)(dataItems),
    dataItemValues = _useState[0],
    setDataItemValues = _useState[1];
  // Popover content can mount before dataItem resolves; keep local state in sync
  // when the parent passes an updated name (common under React 18 timing).
  // Depend on a stable key — `dataItems` is often a new array each render.
  var dataItemsKey = Array.isArray(dataItems) ? dataItems.join("\0") : "";
  var skipInitialSync = (0, _react.useRef)(true);
  (0, _react.useEffect)(function () {
    // Skip the mount pass. React flushes child effects before parent effects,
    // so on mount MultiFieldSelector has already seeded an empty selection via
    // onChange; re-syncing here would immediately overwrite that seed and leave
    // the selector rendering nothing at all. Only later prop changes should win.
    if (skipInitialSync.current) {
      skipInitialSync.current = false;
      return;
    }
    setDataItemValues(dataItems);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataItemsKey]);
  var items = (0, _Device.getDeviceDataItemStats)([device], allowedCategories, ignoredCategories);
  if (items.length === 0) {
    return /*#__PURE__*/_react["default"].createElement(DataItemPopoverContentContainer, {
      isMultiSelector: false,
      backgroundColor: (0, _Theme.val)("background"),
      className: _core.Classes.POPOVER_CONTENT,
      style: {
        padding: "5px"
      }
    }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "DataItemPopoverContent.noItems",
      defaultMessage: 'No data item of category "SAMPLE" present'
    }));
  }
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    _react["default"].createElement(DataItemPopoverContentContainer, {
      isMultiSelector: isMultiSelector,
      colorSelector: colorSelector,
      backgroundColor: (0, _Theme.val)("background"),
      onClick: function onClick(e) {
        return e.stopPropagation();
      },
      onKeyDown: function onKeyDown(e) {
        return e.stopPropagation();
      },
      className: _core.Classes.POPOVER_CONTENT
    }, /*#__PURE__*/_react["default"].createElement(_SelectorFormGroups.DataItemFormGroup, _extends({}, props, {
      items: items,
      dataItemValues: dataItemValues,
      setDataItemValues: setDataItemValues,
      enableAddingNewItem: enableAddingNewItem
    })), /*#__PURE__*/_react["default"].createElement(SaveButton, null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      icon: _icons.IconNames.FLOPPY_DISK,
      intent: _core.Intent.PRIMARY,
      onClick: function onClick() {
        onSubmit(dataItemValues);
      },
      className: _core.Classes.POPOVER_DISMISS,
      "data-testid": "DataItemPopoverContent.save.button"
    }, translate("DataItemPopoverContent.button.save", "Save"))))
  );
}